export type ContextScope = 'global' | 'local';

export interface Action {
    type: ActionType;
    condition: string;
    progress: number;
    targetProgress: number;
    passed: boolean;
    label: string;
    tag: string;
    increaseOnlyWhenCondition: boolean;
    button?: {
        text: string;
        buttonActionType: string;
        payload?: string;
        dataDraw?: string;
        dataSuit?: string;
    };
}

export interface Reward {
    type: RewardType;
    amount: number;
    adAmount: number;
}

export interface Mission {
    startMs: number;
    testPeriodSec?: number;
    actions: Action[];
    type: "daily" | "weekly";
    rewardsClaimed: boolean;
    rewards: Reward[];
    endMs: number;
    isAdditionalMission?: boolean;
}

export interface ActionConfig {
    type: ActionType;
    tag: string;
    condition: string;
    target: {
        min: number;
        max: number;
        step?: number;
    };
    increaseOnlyWhenCondition?: boolean;
    labelKey: string;
    actionButton?: {
        textKey: string;
        buttonActionType: string;
        payload?: string;
        dataDraw?: string;
        dataSuit?: string;
    };
}

export enum RewardType {
    HINTS = 'hints',
    MAGIC_WAND = 'magic_wand'
}

export interface MissionState {
    dailyMission?: Mission;
}

export interface MissionContext {
    local: Record<string, MissionContextData>;
    common: MissionContextData;
}

export interface MissionContextData {
    wins: number;
    moves: number;
    adsWatched: number;
    magicWandUses: number;
    time: number;
    undos: number;
    hints: number;
    deckTurns: number;
}

export interface MissionActionData {
    type: ActionType;
    payload: Record<string, unknown>;
    currentProgress: number;
}

export enum ActionType {
    WINS = 'WINS',
    MOVES = 'MOVES',
    AD = 'AD',
    MAGIC_WAND_USES = 'MAGIC_WAND_USES',
    TIMER = 'TIMER',
    UNDO_MOVE = 'UNDO_MOVE',
    HINTS = 'HINTS',
    DESIGN_CHANGE_BACKGROUND = 'DESIGN_CHANGE_BACKGROUND',
    DESIGN_CHANGE_CARD_FRONT = 'DESIGN_CHANGE_CARD_FRONT',
    DESIGN_CHANGE_CARD_BACK = 'DESIGN_CHANGE_CARD_BACK',
    DECK_TURNS = 'DECK_TURNS',
}

export type AdditionalMissionConfigField = {
    chanceByTag?: Record<string, { count: number, chance: number }>;
    chanceByTagSecondary?: Record<string, { count: number, chance: number }>;
}